import { render, staticRenderFns } from "./ackusativ-och-dativobjekt.vue?vue&type=template&id=37f11ce6&scoped=true"
import script from "./ackusativ-och-dativobjekt.vue?vue&type=script&lang=js"
export * from "./ackusativ-och-dativobjekt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f11ce6",
  null
  
)

export default component.exports